/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_fe35ce74{background:blue}\n"}]);
export const dummy = "dummy_fe35ce74";